const cloudinaryURL = "https://res.cloudinary.com/dvb3cxb9h/image/upload/v1699620958/burger_shop/"

const port = "8000"

const developmentURL = "http://localhost:5005"
// const productionURL = "https://2910273-ca28586.twc1.net";
// const productionURL = "https://94.241.171.18";
// const productionURL = "https://burgerim.ru";
// const productionURL = "https://api.burgerim.ru"
const productionURL = "https://api.qrseller.com"

// export const baseURL =
//   process.env.NODE_ENV === "development" ? developmentURL : productionURL;

const baseURL = process.env.REACT_APP_STAGE === "local" ? developmentURL : productionURL

console.log("process.env.REACT_APP_STAGE", process.env.REACT_APP_STAGE)
console.log("baseURL", baseURL)

const discount = 0.15 // 15% discount

const creditCardInitialData = {
  cardNumber: "1234567890123456",
  expiryDate: "12/23",
  cvv: "123",
  email: "john.doe@example.com",
}

const currencies = [
  { code: "USD", symbol: "$" },
  { code: "EUR", symbol: "€" },
  { code: "RUB", symbol: "₽" },
  { code: "GBP", symbol: "£" },
  { code: "ILS", symbol: "₪" }, // Шекель (Израиль)
]

module.exports = {
  discount,
  creditCardInitialData,
  baseURL,
  port,
  cloudinaryURL,
  currencies,
}
